import { fetchAll, updateDocById, deleteDocById } from "./firestoreHelpers";
import { savePersona, claveDedup } from "./dedupPersona";
import { renameLocadorOnContratos } from "./contratos";
import { nombreCompleto } from "../utils/nombre";

const COLL = "alquileres_locadores";

// Dedup/search key is the full "Apellido Nombre" (falls back to nombre).
const normalizeName = claveDedup;

export const getLocadores = async () => fetchAll(COLL);

// Dedup: if a locador with the same normalized name already exists, fill in
// any missing fields from `data` and return its id. Otherwise create new.
// `nombreNormalizado` is stored alongside so we can query by it cheaply.
export const saveLocador = async (data) => savePersona(COLL, data);

export const updateLocador = async (id, data) => {
  const renamed = data.nombre !== undefined || data.apellido !== undefined;
  const patch = renamed
    ? { ...data, nombreNormalizado: normalizeName(data) }
    : data;
  await updateDocById(COLL, id, patch);
  // Keep the denormalized locadorNombre on every contrato in sync with the rename.
  if (renamed) {
    await renameLocadorOnContratos(id, nombreCompleto(data));
  }
  return id;
};

export const deleteLocador = async (id) => deleteDocById(COLL, id);
